export default __webpack_public_path__ + "static/media/ec.30a0a300.svg";